



































import {Vue, Component} from 'vue-property-decorator';

@Component({
  name: 'Pagination',
  props: {
    btnText: {
      type: String,
      default: '',
    },
    count: {
      type: Number,
      default: 0,
    },
    numberOnPage: {
      type: Number,
      default: 0,
    },
    nextPage: {
      type: String,
      default: '',
    },
    page: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      actualPage: this.page,
    };
  },
  created() {
    this.$parent.$on('changeFilter', () => { this.actualPage = 1; } );
  },
  computed: {
    pages() {
      if (this.count && this.numberOnPage) {
        return Math.ceil(this.count / this.numberOnPage);
      }
    },
  },
  watch: {
    page() {
      this.actualPage = this.page;
    },
  },
  methods: {
    changeActivePageNumber(num) {
      this.actualPage = num;
      const data = {
        page: this.actualPage,
      };
      this.$emit('getActualPage', data);
    },
    addActivePageNumber() {
      if (this.actualPage < this.pages) {
        ++this.actualPage;
        const data = {
          page: this.actualPage,
        };
        this.$emit('addActualPage', data);
      }
    },
  },
})
export default class Pagination extends Vue {
}
